import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ESortOrder, EStatus, EDirection } from './enumTypes';

export interface TFiltersState {
  filters: Partial<{
    page: number;
    pageSize: number;
    dateFrom: string;
    dateTo: string;
    sortOrder: ESortOrder;
    search: string;
    limit: number;
    bankId: string | null;
    clientName: string | null;
    currency: string | null;
    amountFrom: string | null;
    amountTo: string | null;
    channel: string | null;
    status: EStatus | null;
    direction: EDirection,
  }>;
}

const initialState: TFiltersState = {
  filters: {
    page: 1,
    pageSize: 20,
    dateFrom: undefined,
    dateTo: undefined,
    sortOrder: ESortOrder.DESC,
    limit: 20,
    bankId: null,
    clientName: null,
    currency: null,
    amountFrom: null,
    amountTo: null,
    channel: null,
    status: null,
    direction: EDirection.OUTWARD,
  }
};

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<TFiltersState['filters']>) => {
      state.filters = action.payload;
    },
  },
});

export default filtersSlice.reducer;
export const { setFilters } = filtersSlice.actions;